/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getGenericTokenIframe } from '../../store/dashboardHl/actions';
import { changeTitleBanner } from '../../store/actions';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import usePageTitle from '../../common/hooks/usePageTitle';
import { getNameClient } from '../../helpers/nameClient';
import { Page, Card, EmptyState } from '../../components/ihub';

// Solo se abre un dashboard que esté en los permisos del usuario. Si alguien escribe a mano /Analytics/<id>
// sin ese permiso, ve la pantalla de "No access" del kit.
const GenericHollistics = (props: any) => {
    const dispatch = useDispatch();
    const PageTitleRolM = usePageTitle(props.location.pathname);
    const { id } = useParams<any>();

    const { token } = useSelector((state: any) => ({ token: state.DashboardHL.token }));
    const [urlState, setURLState] = useState<any>();
    const [state, setState] = useState<any>({
        currentHollistic: undefined,
        revisado: false,
    });

    const extractDataJson = (jsCode: any, dataRegex: RegExp) => {
        const match = dataRegex.exec(jsCode);
        if (match && match[1]) {
            return JSON.stringify(eval('(' + match[1] + ')'))
        } else {
            return {}
        }
    }

    useEffect(() => {
        if (token && state.currentHollistic) {
            let url = state.currentHollistic?.URL;
            if (!url.endsWith('/')) url = url + '/';
            const identificator = state.currentHollistic?.holisticsClientIdentificator;

            setURLState(url + identificator + "?_token=" + token);
        }

    }, [token, state.currentHollistic]);
    useEffect(() => {
        let permissions: any[] = [];
        try {
            permissions = JSON.parse(String(localStorage.getItem('permisos'))) || [];
        } catch (e) {
            permissions = [];
        }
        const currentHollistic = Array.isArray(permissions) ? permissions.find((item: any) => item.id == id) : undefined;

        if (currentHollistic && currentHollistic.identificator === "Holistics") {
            const formatFilters = extractDataJson(
                currentHollistic.JSONHollistics,
                /var\s+filters\s*=\s*({[\s\S]*?});/
            );
            const formatPermissions = extractDataJson(
                currentHollistic.JSONHollistics,
                /var\s+permissions\s*=\s*({[\s\S]*?});/
            );
            dispatch(getGenericTokenIframe({
                secretKey: currentHollistic.clientSecret,
                filters: formatFilters,
                permissions: formatPermissions
            }));
            dispatch(changeTitleBanner(currentHollistic.nombre));
            setState({ currentHollistic, revisado: true });
        } else {
            dispatch(changeTitleBanner(''));
            setState({ currentHollistic: undefined, revisado: true });
        }
    }, [id]);

    if (state.revisado && !state.currentHollistic) {
        return (
            <Page theme="brand" title="No access">
                <PageTitle>
                    <title>No access | {getNameClient()}</title>
                </PageTitle>
                <Card>
                    <EmptyState icon="bx-lock-alt" title="No access" text="You don't have access to this dashboard." />
                </Card>
            </Page>
        );
    }

    return (
        <React.Fragment>
            <PageTitle>
                <title>{PageTitleRolM.replace(/-/g, ' ')} | {getNameClient()}</title>
            </PageTitle>
            {state.currentHollistic && urlState ?
                (<iframe
                    data-v-9b74a260=""
                    src={`${urlState}`}
                    className="embedded-dashboard-iframe h-[800px] w-full"
                    frameBorder="0"
                    allowFullScreen={true}
                    width="100%"
                    height="900px"
                    style={{ marginTop: '60px' }}
                ></iframe>) :
                <div className='pt-5 mt-5'>
                    <div className='d-flex justify-content-center align-items-center'>
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>
    );
};

export default GenericHollistics;
